import React from 'react'
import { Logos } from '../../data/Assets'
import cookiesModifier from '../../utils/cookies';
import { useNavigate } from 'react-router-dom';
import { ImageAsset } from '../wrappers/ImageAsset';

const Header = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    cookiesModifier.removeCookie('imm_consultant_token');
    navigate("/login", { replace: true });
  }
  return (
    <div className='imm_consultant__header_cont'>
      <div className='logo_cont'>
        <div className='logo_div'>
          <ImageAsset src={Logos.Logo} alt="" className='fit_asset_max' />
        </div>
      </div>
      <div className='logout_btn__cont'>
        <button className='logout_btn' onClick={handleLogout}><span>Logout</span></button>
      </div>
    </div>
  )
}

export default Header;